<template>
  <div class="index-con">
    <Header @logout="logout"></Header>
    <main class="buyer-main-con">
      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { mapActions } from 'vuex'
import indexApi from '@/api/index/indexApi.js'

  export default {
    name: 'index',
    data () {
      return {}
    },
    created () {
      this.getShopByDomain()
    },
    mounted () {
    },
    methods: {
      ...mapActions([
        'getCurrencyList'
      ]),
      async getShopByDomain () {
        let params = {
          // domain: 'test1.moshopy.com'
          domain: location.hostname
        }
        const res =  await indexApi.getShopByDomain(params)
        if (!res.data.code) {
          localStorage.setItem('shopId', res.data.data && res.data.data.shopId ? res.data.data.shopId : '')
          localStorage.setItem('paypalQuickPay', res.data.data && res.data.data.paypalQuickPay ? 1 : 0)
        }
        await this.getCurrencyList()
      },
      logout () {
        localStorage.setItem('currHref', window.location.href)
        window.location.href = '/' // 测试环境登录页
      }
    },
    components: {
      Header
    }
  }
</script>

<style lang="less">
  @import "~assets/style/variable";
  .index-con {
    padding-top: 90px;
    .buyer-main-con {
      min-height: calc(~'100vh - 90px');
    }
  }
</style>
